import React, { useState, useEffect } from 'react';
import PropTypes from "prop-types";
import CsfFournisseurPagination from "../includes/csf-fournisseur-pagination";
import PivotalFormApi from "../../../js/csf/pivotal/PivotalFormApi";
import { stopLoadingSpinner } from "../../csf-ufc-pivotal/includes/utils";
import { clearSearchBtn } from '../includes/utils';

export function CsfPivotalFournisseurAddFormateurList({
  trainersList,
  total,
  startRow,
  offset,
  setStartRowListFunction,
  triggerTrainerListSearch,
  accessToken,
  apiUrl,
  apiEnv,
  importTrainerList
}) {
  const [inputSearchValue, setInputSearchValue] = useState('');
  const [checkedTrainers, setCheckedTrainers] = useState('');
  const [multipleTrainers, setMultipleTrainers] = useState('');
  const [selectedList, setSelectedList] = useState('');

  useEffect(() => {
    setCheckedTrainers(0);
    setMultipleTrainers(true);
    if (document.documentElement.lang === "fr") {
      setMultipleTrainers(false);
    }
  }, []);


  useEffect(() => {
    setMultipleTrainers(hasMultiple);
  }, [checkedTrainers]);

  /*
  * Method that handle search input change
  * */
  const handleSearchChange = (event) => {
    setInputSearchValue(event.target.value);
  };

  /*
  * Method that handle search submit
  * */
  const handleSearchBtn = (event) => {
    if (event.key === 'Enter' || event.type === "click") {
      triggerTrainerListSearch(inputSearchValue);
    }
  };

  /*
  * Method that reset search
  * */
  const handleResetSubmit = () => {
    // Reset the checked inputs
    const inputs = document.querySelectorAll('#list-formateur-table input[type="checkbox"]:checked');
    if (inputs) {
      inputs.forEach(input => {
        input.click();
      })
    }

    setInputSearchValue('');
    triggerTrainerListSearch('');
    setSelectedList('');
    setCheckedTrainers(0);
  };

  /*
  * Method that handle the checkbox change
  * */
  const handleCheckboxChange = (event) => {
    if (event.target.checked) {
      setCheckedTrainers(checkedTrainers + 1);
      const newList = trainersList.find(item => item.CSF_EP_List_Id === event.target.value);
      setSelectedList([...selectedList, newList])
    } else {
      setCheckedTrainers(checkedTrainers - 1);
      const newArray = selectedList.filter(item => item.CSF_EP_List_Id !== event.target.value);
      setSelectedList(newArray);
    }
  };

  /*
  * Update the number count
  * */
  const hasMultiple = () => {
    return checkedTrainers > 1 || (checkedTrainers === 0 && document.documentElement.lang === "en");
  };

  /*
  * Method that get all the trainers associated to the list to later import them
  * */
  function importTrainingList() {
    let trainersOfList = [];
    if (selectedList && selectedList.length > 0) {
      const fetchPromises = selectedList.map((list) => {
        const requestData = {
          form: "CSF_EP_UXContactList_Info",
          recordId: list.CSF_EP_List_Id,
        };
        const pivotalFormApi = new PivotalFormApi(apiUrl, apiEnv, accessToken);
        return pivotalFormApi.callFormRecuperationEndpoint(requestData, '_Espace_Partenaire');
      });

      // Wait for all promises to resolve
      Promise.all(fetchPromises)
        .then(responses => {
          trainersOfList = [].concat(...responses.map(response =>
            renameObjectKeys(response?.payload?.data?.primary?.CSF_EP_List_Contact_Bridge__Secondary, {
              'Courriel': 'Contact_Email',
              'GSFT_Status_Id__Rn_Descriptor': 'Contact_Status'
            }) || []
          ));
          importTrainerList(trainersOfList);
          $("[data-dismiss=modal]").trigger({ type: "click" });
        })
        .catch(error => {
          stopLoadingSpinner();
          console.error(error);
        });
    }
  }

  /*
  * Method that change some object key names to match a certain name (sometimes the api return different format ex: Courriel vs Contact_Email.
  * */
  function renameObjectKeys(objects, keyMap) {
    objects.forEach(obj => {
      for (let oldKey in keyMap) {
        if (obj.hasOwnProperty(oldKey)) {
          obj[keyMap[oldKey]] = obj[oldKey];
          delete obj[oldKey];
        }
      }
    });

    return objects;
  }

  /*
  * Method that trigger an empty search when X button is clicked in the search field.
  * */
  function retriggerEmptySearch() {
    setInputSearchValue('');
    triggerTrainerListSearch('');
  }


  return (
    <div className="modal fade" id="addFormateurList" tabIndex="-1" role="dialog"
      aria-labelledby="addFormateurListLabel" aria-hidden="true">
      <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <h2 id="addFormateurListLabel">
              {window.Drupal.t('fournisseur.add.formateur.list.form.modal.title')}
            </h2>
            <button type="button" className="close" data-dismiss="modal" onClick={handleResetSubmit}
              aria-label={window.Drupal.t('lang.modal.close')}>
              <i className="icon icon-csf-close-noborder"><span className="d-none">&nbsp;</span></i>
            </button>
          </div>

          <div className="modal-body">
            <div className="modal-list">
              <div className="search-container">
                <label htmlFor="addFormateurListSearch"
                  className="sr-only">{window.Drupal.t('fournisseur.search.placeholder')}</label>
                <input type="search" id="addFormateurListSearch" value={inputSearchValue} onChange={handleSearchChange} onKeyDown={handleSearchBtn}
                  placeholder={window.Drupal.t('fournisseur.search.placeholder')} />
                <button className="search-close-icon btn-link" aria-label={window.Drupal.t('fournisseur.search.clear.label')}
                  onClick={(e) => {
                    clearSearchBtn(e, setInputSearchValue);
                    retriggerEmptySearch();
                  }}
                >
                  <i className="icon icon-remove"></i>
                </button>
                <button className="button btn-outlined search-icon" onClick={handleSearchBtn}
                  title={window.Drupal.t('search.label')} aria-label={window.Drupal.t('search.label')}>
                  <i className="icon icon-search-2"><span className="d-none">&nbsp;</span></i>
                </button>
              </div>

              <div className="table-wrapper">
                <table id="list-formateur-table">
                  <caption id="formateur-list-caption"
                    className="sr-only">{window.Drupal.t('fournisseur.trainers.listing.table.title')}</caption>
                  <thead>
                    <tr>
                      <th width="50"></th>
                      <th width="65%">{window.Drupal.t('fournisseur.trainers.listing.table.name')}</th>
                      <th>{window.Drupal.t('fournisseur.add.formateur.table.nb.col.label')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {trainersList.length === 0 ? (
                      <tr>
                        <td colSpan="6">
                          <p>{window.Drupal.t('fournisseur.empty.training.list')}</p>
                        </td>
                      </tr>
                    ) : (
                      trainersList.map((trainer) => (
                        <tr key={trainer.CSF_EP_List_Id}>
                          <td>
                            <div className="form-group special-padding">
                              <input id={trainer.CSF_EP_List_Id} onChange={handleCheckboxChange}
                                value={trainer.CSF_EP_List_Id} type="checkbox" name="formateurSelected" />
                              <label htmlFor={trainer.CSF_EP_List_Id} className="sr-only">{trainer.List_Name}</label>
                            </div>
                          </td>
                          <td>{trainer.List_Name}</td>
                          <td>
                            {(trainer.Nb_Formateurs !== null && trainer.Nb_Formateurs !== undefined) && (
                              trainer.Nb_Formateurs + ' ' + window.Drupal.t('fournisseur.modal.btn.formateur') +
                              (trainer.Nb_Formateurs > 1 ? 's' : '')
                            )}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>

          </div>

          <div className="modal-footer d-flex justify-content-between">
            <div className="modal-pagination">
              <CsfFournisseurPagination
                startRow={startRow}
                offset={offset}
                total={total}
                setStartRowFunction={setStartRowListFunction}
              />
            </div>

            <div className="buttons-wrapper">
              <button type="button" className="button btn-outlined btn-larger" onClick={handleResetSubmit}
                data-dismiss="modal">{window.Drupal.t('fournisseur.cancel.btn')}</button>
              <button type="button" onClick={importTrainingList} className="button btn-filled btn-larger" id="modalSaveButton">
                {window.Drupal.t('fournisseur.add.formateur.list.import.label')} {checkedTrainers} {window.Drupal.t('fournisseur.add.formateur.list.list.label')}{multipleTrainers ? 's' : ''}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

CsfPivotalFournisseurAddFormateurList.propTypes = {
  trainersList: PropTypes.array.isRequired,
  total: PropTypes.number,
  startRow: PropTypes.number,
  offset: PropTypes.number,
  setStartRowListFunction: PropTypes.func,
  triggerTrainerListSearch: PropTypes.func,
  accessToken: PropTypes.String,
  apiUrl: PropTypes.String,
  apiEnv: PropTypes.String,
  importTrainerList: PropTypes.func
};
